import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const Index = React.lazy(() => import("@/pages/travelClaims"));
const MyTeam = React.lazy(() => import("@/pages/travelClaims/MyTeam"));

const TravelClaims = [
  {
    
        path: "/travelRequest",
        element: (
          <SuspenseWrapper>
            <Index />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/myTeamsTravel",
        element: (
          <SuspenseWrapper>
            <MyTeam />
          </SuspenseWrapper>
        ),
      },
    ];



export default TravelClaims;
